var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 20.0009H2C0.89543 20.0009 0 19.1054 0 18.0009V2.00087C0 0.896302 0.89543 0.000871474 2 0.000871474H9C9.00896 -0.000290491 9.01804 -0.000290491 9.027 0.000871474H9.033C9.04244 0.00382953 9.05216 0.00583946 9.062 0.00687147C9.15019 0.0125247 9.23726 0.0296696 9.321 0.0578715H9.336H9.351H9.363C9.38145 0.0707972 9.39884 0.0851763 9.415 0.100871C9.52394 0.149295 9.62321 0.217056 9.708 0.300871L15.708 6.30087C15.7918 6.38566 15.8596 6.48493 15.908 6.59387C15.917 6.61587 15.924 6.63687 15.931 6.65987L15.941 6.68787C15.9689 6.77126 15.9854 6.85805 15.99 6.94587C15.9909 6.95583 15.9932 6.96561 15.997 6.97487V6.98087C15.9986 6.98743 15.9996 6.99412 16 7.00087V18.0009C16 18.5313 15.7893 19.04 15.4142 19.4151C15.0391 19.7902 14.5304 20.0009 14 20.0009ZM9 2.00087V7.00087H14L9 2.00087Z",
    fill: "#2E3A59"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/fileIcon.75bd8e27.svg";
export { ForwardRef as ReactComponent };